module.exports = __webpack_public_path__ + "img/ring_g_s_0_null@3x.246ed6b0.png";